<template>
  <div>
    <div class="status" :class="[status == 2 ? 'error-status' : '']">
      <div class="status-info">
        <div>
          <div class="status-name">{{ statusText }}</div>
          <div class="time">申请时间：{{ info.createTime }}</div>
        </div>
        <img
          class="time-icon"
          v-if="status == 3"
          src="../../static/images/applyInfo/time.png"
          alt=""
        />
        <img
          class="time-icon"
          src="../../static/images/applyInfo/success.png"
          alt=""
          v-if="status == 1"
        />
        <img
          class="time-icon"
          src="../../static/images/applyInfo/error.png"
          alt=""
          v-if="status == 2"
        />
      </div>
      <div v-if="status == 2 && info.resultDescribe" class="error-msg">
        {{ info.resultDescribe }}
      </div>
    </div>
    <div class="detail-item">
      <div class="main-item">
        <div class="name">{{ info.productName }}</div>
        <div class="number">保单号：{{ info.policyNo }}</div>
      </div>
      <div class="item" v-for="(item, index) in info.garmtee" :key="index">
        <span class="title">{{ item.premiseAttribute }}</span>
        <span class="content">{{ item.guaranteeMoney }}</span>
      </div>
      <div class="item">
        <span class="title">出险人</span>
        <span class="content">{{ info.insurederName }}</span>
      </div>
      <div class="item">
        <span class="title">出险类型</span>
        <span class="content">{{ info.Stricken ? "重疾" : "非重疾" }}</span>
      </div>
      <div class="item">
        <span class="title">联系人姓名</span>
        <span class="content">{{ info.contactName }}</span>
      </div>
      <div class="item">
        <span class="title">联系人手机号码</span>
        <span class="content">{{ info.contactMobile }}</span>
      </div>
    </div>
    <div class="detail-item">
      <div class="main-title">出险信息</div>
      <div class="info" :class="{ 'error-info': status == 2 }">
        {{ info.accidentDescribe }}
      </div>
    </div>
    <div class="detail-item" v-if="status == 3">
      <div class="main-title">理赔提示<span>（请保管好以下资料）</span></div>
      <div class="apply-tip">
        <div>
          <img
            src="../../static/images/applyInfo/confirm-icon.png"
            alt=""
          />正式收据，门诊/住院费用清单，社保结算单
        </div>
        <div>
          <img
            src="../../static/images/applyInfo/confirm-icon.png"
            alt=""
          />相关检查及检验报告
        </div>
        <div>
          <img
            src="../../static/images/applyInfo/confirm-icon.png"
            alt=""
          />意外事故证明（公安机关等机构出具的资料）等
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loading } from "@/api/mixins";
export default {
  mixins: [loading],
  data() {
    return {
      status: 0, //1成功 2失败 3未处理
      statusText: "",
      id: "",
      plat: "",
      info: {}, //订单信息
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.plat = this.$route.query.plat;
    this.loading = true;
    this.getDetail();
  },
  mounted() {
    this.$weixin.hideMenu();
  },
  methods: {
    getDetail() {
      this.$http({
        type: "PUT",
        url: `/api/compensation/getCompensationDetail/${this.plat}/${this.id}`,
      })
        .then((result) => {
          this.loading = false;
          this.info = result.data;
          if (this.info.claimsState == 1) {
            //1已结案 0,2处理中
            if (this.info.claimsResult == 1) {
              //1成功0失败
              //1成功2失败
              this.statusText = "理赔成功";
              this.status = 1;
            } else {
              this.statusText = "理赔失败";
              this.status = 2;
            }
          } else {
            this.status = 3;
            this.statusText = "理赔中";
          }
        })
        .catch((error) => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.status {
  padding: 30px 30px 33px;
  background: linear-gradient(210deg, #236dff 0%, #234dff 100%);
  opacity: 1;
  color: #ffffff;
  .status-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .time-icon {
      width: 66px;
      height: 66px;
    }
  }
  .status-name {
    font-size: 34px;
    font-weight: 500;
  }
  .time {
    font-size: 26px;
    font-weight: 400;
    margin-top: 12px;
  }
}
.error-status {
  background: linear-gradient(210deg, #9aa6be 0%, #5a6c8b 100%);
  box-shadow: 0px 1px 6px rgba(35, 109, 255, 0.3);
}
.error-msg {
  background: rgba(249, 250, 251, 0.1);
  border-radius: 10px;
  padding: 10px 0 10px 20px;
  font-size: 28px;
  font-weight: 400;
  line-height: 44px;
  color: #ffffff;
  margin-top: 20px;
}
.detail-item {
  background-color: #fff;
  margin-top: 20px;
  .main-title {
    font-size: 34px;
    font-weight: bold;
    height: 100px;
    line-height: 100px;
    padding-left: 30px;
    border-bottom: 1px solid #ececec;
    span {
      font-size: 24px;
      font-weight: 400;
      line-height: 33px;
      color: #515c6f;
      opacity: 1;
    }
  }
  .item {
    display: flex;
    justify-content: space-between;
    padding: 0 30px 30px;
    font-size: 28px;
    font-weight: 400;
    line-height: 50px;
    .title {
      color: #666666;
    }
    .content {
      color: #333333;
    }
  }
  .main-item {
    padding: 30px;
    margin-bottom: 30px;
    border-bottom: 1px solid #eeeeee;
    .name {
      font-size: 34px;
      font-weight: bold;
      line-height: 34px;
      color: #333333;
    }
    .number {
      margin-top: 10px;
      font-size: 28px;
      font-weight: 400;
      line-height: 34px;
      color: #666666;
    }
  }
  .info {
    font-size: 30px;
    color: #555;
    padding: 30px;
    line-height: 50px;
  }
  .error-info {
    padding-bottom: 313px;
  }
}
.apply-tip {
  flex-direction: column;
  padding: 26px 30px 27px;
  font-size: 30px;
  color: #555;
  > div {
    margin-bottom: 15px;
  }
  img {
    width: 32px;
    height: 22px;
    margin-right: 10px;
  }
}
</style>